// ABOUTME: React context for AddLinkModal state management
// ABOUTME: Allows any component to trigger the modal without rendering duplicate instances

"use client"

import { createContext, useContext, useState, useCallback, ReactNode } from "react"
import { AddLinkModal } from "@/components/nav/add-link-modal"

interface AddLinkModalContextValue {
  openAddLinkModal: () => void
  closeAddLinkModal: () => void
  isOpen: boolean
}

const AddLinkModalContext = createContext<AddLinkModalContextValue | null>(null)

export function AddLinkModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openAddLinkModal = useCallback(() => {
    setIsOpen(true)
  }, [])

  const closeAddLinkModal = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <AddLinkModalContext.Provider
      value={{
        openAddLinkModal,
        closeAddLinkModal,
        isOpen,
      }}
    >
      {children}
      {/* Single instance of the modal */}
      <AddLinkModal isOpen={isOpen} onClose={closeAddLinkModal} />
    </AddLinkModalContext.Provider>
  )
}

export function useAddLinkModal() {
  const context = useContext(AddLinkModalContext)
  if (!context) {
    throw new Error('useAddLinkModal must be used within an AddLinkModalProvider')
  }
  return context
}
